import { styled } from "styled-components";

export const Input = styled.input`
  width: 70%;
  background-color: var(--white);
  font-size: 12px;
  border: none;
  outline: none;
`;
